(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class AnnouncementBarController {
      constructor(root) {
        this.root = root;
        this.mode = root.dataset.announcementMode;
        this.viewport = root.querySelector('[data-announcement-viewport]');
        this.list = root.querySelector('[data-announcement-list]');
        this.scroller = this.list;
        this.items = Array.from(root.querySelectorAll('[data-announcement-list]:not([aria-hidden="true"]) [data-announcement-item]'));

        if (!this.viewport || !this.list || this.items.length < 2) return;

        if (this.mode === 'carousel') this.initCarousel();
        if (this.mode === 'marquee') this.initMarquee();
      }

      initCarousel() {
        const prev = this.root.querySelector('[data-announcement-prev]');
        const next = this.root.querySelector('[data-announcement-next]');
        if (!prev || !next) return;

        this.syncCarouselWidth();
        this.activeIndex = this.getCurrentIndex();
        this.isAnimating = false;
        this.prevButton = prev;
        this.nextButton = next;
        this.handlePrevClick = () => this.scrollByDirection(-1);
        this.handleNextClick = () => this.scrollByDirection(1);
        this.prevButton.addEventListener('click', this.handlePrevClick);
        this.nextButton.addEventListener('click', this.handleNextClick);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.syncCarouselWidth());
          this.resizeObserver.observe(this.root);
        }
      }

      getCurrentIndex() {
        const scrollerCenter = this.scroller.scrollLeft + this.scroller.clientWidth / 2;

        return this.items.reduce((closestIndex, item, index) => {
          const itemCenter = this.getItemScrollLeft(item) + item.offsetWidth / 2;
          const closestItem = this.items[closestIndex];
          const closestCenter = this.getItemScrollLeft(closestItem) + closestItem.offsetWidth / 2;

          return Math.abs(itemCenter - scrollerCenter) < Math.abs(closestCenter - scrollerCenter)
            ? index
            : closestIndex;
        }, 0);
      }

      getItemScrollLeft(item) {
        const itemRect = item.getBoundingClientRect();
        const scrollerRect = this.scroller.getBoundingClientRect();

        return itemRect.left - scrollerRect.left + this.scroller.scrollLeft;
      }

      scrollByDirection(direction) {
        if (this.isAnimating) return;

        const total = this.items.length;
        const current = Number.isInteger(this.activeIndex) ? this.activeIndex : this.getCurrentIndex();
        const nextIndex = (current + direction + total) % total;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const wrappingForward = direction === 1 && current === total - 1;
        const wrappingBackward = direction === -1 && current === 0;

        // Normal step (no wrap)
        if (!wrappingForward && !wrappingBackward) {
          this.activeIndex = nextIndex;
          const nextItem = this.items[nextIndex];
          const maxScrollLeft = this.scroller.scrollWidth - this.scroller.clientWidth;
          const centeredLeft = this.getItemScrollLeft(nextItem) - (this.scroller.clientWidth - nextItem.offsetWidth) / 2;
          const left = Math.max(0, Math.min(maxScrollLeft, centeredLeft));
          this.scroller.scrollTo({ left, behavior: reduced ? 'auto' : 'smooth' });
          return;
        }

        // Wrap-around: simulate continuous direction with a temporary clone
        if (reduced) {
          this.activeIndex = nextIndex;
          const targetItem = this.items[nextIndex];
          const centeredLeft = this.getItemScrollLeft(targetItem) - (this.scroller.clientWidth - targetItem.offsetWidth) / 2;
          this.scroller.scrollTo({ left: Math.max(0, centeredLeft), behavior: 'auto' });
          return;
        }

        this.isAnimating = true;

        // Clone the target slide and append it on the opposite side, then animate towards it.
        // Cloned nodes are aria-hidden and tabindex=-1 so they don't interfere with accessibility/SEO.
        const sourceItem = wrappingForward ? this.items[0] : this.items[total - 1];
        const clone = sourceItem.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-announcement-clone-tmp', '');
        clone.removeAttribute('data-announcement-item');
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        });

        const restoreSnap = this.scroller.style.scrollSnapType;
        this.scroller.style.scrollSnapType = 'none';

        if (wrappingForward) {
          // Append after last so the carousel continues to the right
          this.list.appendChild(clone);
          requestAnimationFrame(() => {
            const targetLeft = this.scroller.scrollWidth - this.scroller.clientWidth;
            this.scroller.scrollTo({ left: targetLeft, behavior: 'smooth' });
          });
        } else {
          // Prepend before first so the carousel continues to the left.
          // Prepending shifts the existing items by clone's width, so we offset scrollLeft instantly.
          this.list.insertBefore(clone, this.list.firstChild);
          requestAnimationFrame(() => {
            const cloneWidth = clone.offsetWidth;
            // Instantly compensate so the view doesn't jump
            this.scroller.scrollLeft = this.scroller.scrollLeft + cloneWidth;
            // Then animate to the clone (at index 0)
            requestAnimationFrame(() => {
              this.scroller.scrollTo({ left: 0, behavior: 'smooth' });
            });
          });
        }

        // After the visual animation finishes, swap to the real target without animation
        const cleanup = () => {
          this.activeIndex = nextIndex;
          const realTarget = this.items[nextIndex];
          const centeredLeft = this.getItemScrollLeft(realTarget) - (this.scroller.clientWidth - realTarget.offsetWidth) / 2;
          this.scroller.style.scrollBehavior = 'auto';
          this.scroller.scrollLeft = Math.max(0, centeredLeft);
          clone.remove();
          // Restore
          this.scroller.style.scrollBehavior = '';
          this.scroller.style.scrollSnapType = restoreSnap;
          this.isAnimating = false;
        };

        // scrollTo smooth doesn't fire a reliable event; use a timeout matching CSS smooth duration
        window.setTimeout(cleanup, 500);
      }

      syncCarouselWidth() {
        const controlSpace = 90;
        const availableWidth = Math.max(180, this.root.clientWidth - controlSpace);
        const contentWidths = this.items.map((item) => {
          const content = item.querySelector('.announcement-bar__content');
          return content ? Math.ceil(content.scrollWidth) : Math.ceil(item.scrollWidth);
        });
        const targetWidth = Math.min(Math.max(...contentWidths) + 36, availableWidth);

        this.root.style.setProperty('--announcement-carousel-width', `${targetWidth}px`);
      }

      initMarquee() {
        this.track = this.root.querySelector('[data-announcement-marquee-track]');
        if (!this.track) return;

        this.prepareMarquee();

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.prepareMarquee());
          this.resizeObserver.observe(this.viewport);
        }
      }

      destroy() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.prevButton && this.handlePrevClick) this.prevButton.removeEventListener('click', this.handlePrevClick);
        if (this.nextButton && this.handleNextClick) this.nextButton.removeEventListener('click', this.handleNextClick);
      }

      prepareMarquee() {
        this.track.querySelectorAll('[data-announcement-clone]').forEach((clone) => clone.remove());
        this.track.dataset.announcementMarqueeReady = 'false';

        const distance = this.list.scrollWidth;
        if (distance <= 0) return;

        this.track.style.setProperty('--announcement-marquee-distance', `${distance}px`);

        let guard = 0;
        while (this.track.scrollWidth < this.viewport.clientWidth + distance && guard < 8) {
          const clone = this.list.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.dataset.announcementClone = 'true';
          clone.removeAttribute('data-announcement-list');
          clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((node) => {
            node.setAttribute('tabindex', '-1');
          });
          clone.querySelectorAll('*').forEach((node) => {
            Array.from(node.attributes).forEach((attribute) => {
              if (attribute.name.startsWith('data-shopify')) node.removeAttribute(attribute.name);
            });
          });
          this.track.appendChild(clone);
          guard += 1;
        }

        this.track.dataset.announcementMarqueeReady = 'true';
      }
    }

    function initAnnouncementBars(scope = document) {
      scope.querySelectorAll('[data-announcement-bar]').forEach((root) => {
        if (root.announcementBarController) root.announcementBarController.destroy();
        root.announcementBarController = new AnnouncementBarController(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAnnouncementBars());
    } else {
      initAnnouncementBars();
    }

    document.addEventListener('shopify:section:load', (event) => initAnnouncementBars(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var tab = event.target.closest('.flavor-menu__tab');
    if (!tab) return;

    var menu = tab.closest('.flavor-menu');
    if (!menu) return;

    var target = tab.dataset.tab;
    if (!target) return;

    menu.querySelectorAll('.flavor-menu__tab').forEach(function(button) {
      var isActive = button === tab;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    menu.querySelectorAll('[data-tab-panel]').forEach(function(panel) {
      var isActive = panel.dataset.tabPanel === target;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  });

  (function() {
    var videoObserver = null;

    function getVideo(media) {
      return media.querySelector('video');
    }

    function getToggle(media) {
      return media.querySelector('[data-accordion-video-toggle]');
    }

    function getSoundToggle(media) {
      return media.querySelector('[data-accordion-video-sound]');
    }

    function setSoundState(media, isMuted) {
      var sound = getSoundToggle(media);
      if (!sound) return;

      sound.setAttribute('aria-label', isMuted ? 'Activer le son' : 'Couper le son');
      sound.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
      media.classList.toggle('is-unmuted', !isMuted);
    }

    function isOpen(media) {
      var details = media.closest('details');
      return !details || details.open;
    }

    function setToggleState(media, isPlaying) {
      var toggle = getToggle(media);
      if (!toggle) return;

      toggle.setAttribute('aria-label', isPlaying ? 'Mettre en pause' : 'Lire la vidéo');
      toggle.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    }

    function warmVideo(video) {
      if (video.dataset.accordionVideoWarmed === 'true') return;
      video.dataset.accordionVideoWarmed = 'true';
      video.preload = 'auto';
      video.load();
    }

    function pauseVideo(media) {
      var video = getVideo(media);
      if (!video) return;

      video.pause();
      media.classList.remove('is-playing');
      media.classList.remove('is-awaiting-frame');
      setToggleState(media, false);
    }

    function playVideo(media) {
      var video = getVideo(media);
      if (!video || !isOpen(media)) return;

      warmVideo(video);
      media.classList.add('is-awaiting-frame');

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {
          media.classList.remove('is-awaiting-frame');
          setToggleState(media, false);
        });
      }
    }

    function initAccordionVideos(root) {
      var medias = (root || document).querySelectorAll('[data-accordion-video-media]');
      if (!medias.length) return;

      medias.forEach(function(media) {
        if (media.dataset.accordionVideoInit === 'true') return;

        var video = getVideo(media);
        if (!video) return;

        media.dataset.accordionVideoInit = 'true';

        video.addEventListener('playing', function() {
          media.classList.add('is-playing');
          media.classList.remove('is-awaiting-frame');
          setToggleState(media, true);
        });

        video.addEventListener('pause', function() {
          media.classList.remove('is-playing');
          media.classList.remove('is-awaiting-frame');
          setToggleState(media, false);
        });

        video.addEventListener('ended', function() {
          media.classList.remove('is-playing');
          media.classList.remove('is-awaiting-frame');
          setToggleState(media, false);
        });

        var toggle = getToggle(media);
        if (toggle) {
          toggle.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();

            if (media.classList.contains('is-playing') || !video.paused) {
              pauseVideo(media);
            } else {
              playVideo(media);
            }
          });
        }

        var sound = getSoundToggle(media);
        if (sound) {
          setSoundState(media, video.muted);
          sound.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            video.muted = !video.muted;
            if (!video.muted) {
              video.volume = 1;
            }
            setSoundState(media, video.muted);
          });
          video.addEventListener('volumechange', function() {
            setSoundState(media, video.muted);
          });

          var tryUnmute = function() {
            if (!video.muted) return;
            video.muted = false;
            video.volume = 1;
            setSoundState(media, false);
          };
          ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach(function(evt) {
            window.addEventListener(evt, tryUnmute, { once: true, passive: true, capture: true });
          });
        }

        var details = media.closest('details');
        if (details) {
          details.addEventListener('toggle', function() {
            if (details.open) {
              playVideo(media);
            } else {
              pauseVideo(media);
            }
          });
        }

        if (videoObserver) {
          videoObserver.observe(media);
        } else if (isOpen(media)) {
          playVideo(media);
        }
      });
    }

    if ('IntersectionObserver' in window) {
      videoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            playVideo(entry.target);
          } else {
            pauseVideo(entry.target);
          }
        });
      }, { rootMargin: '240px 0px', threshold: 0.01 });
    }

    initAccordionVideos(document);

    document.addEventListener('shopify:section:load', function(event) {
      initAccordionVideos(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-v3"] && !Shopify.designMode) return;
  try {
    
  var footerV3DesktopMq = window.matchMedia('(min-width: 990px)');

  function syncFooterV3DetailsForViewport(footer) {
    var isDesktop = footerV3DesktopMq.matches;
    footer.querySelectorAll('.footer-v3__menu-column').forEach(function(details) {
      if (isDesktop) {
        // Sur desktop, tous les <details> sont open pour exposer leur contenu
        // (le CSS masque l'icône et désactive le toggle).
        if (!details.open) details.open = true;
      } else {
        // Sur mobile, on respecte l'état initial souhaité.
        if (details.dataset.defaultOpen !== 'true' && details.open) {
          details.open = false;
        }
      }
    });
  }

  function initFooterV3(root) {
    (root || document).querySelectorAll('[data-footer-v3]').forEach(function(footer) {
      if (footer.dataset.footerV3Init === 'true') return;

      footer.dataset.footerV3Init = 'true';

      // Mémorise l'état d'ouverture initial pour chaque <details> (state mobile par défaut)
      footer.querySelectorAll('.footer-v3__menu-column').forEach(function(details) {
        details.dataset.defaultOpen = details.open ? 'true' : 'false';
      });

      syncFooterV3DetailsForViewport(footer);
      footerV3DesktopMq.addEventListener('change', function() {
        syncFooterV3DetailsForViewport(footer);
      });

      var singleOpen = footer.dataset.singleOpen === 'true';
      if (!singleOpen) return;

      footer.querySelectorAll('.footer-v3__menu-column').forEach(function(details) {
        details.addEventListener('toggle', function() {
          if (!details.open || !window.matchMedia('(max-width: 989px)').matches) return;

          footer.querySelectorAll('.footer-v3__menu-column[open]').forEach(function(other) {
            if (other !== details) other.removeAttribute('open');
          });
        });
      });
    });
  }

  initFooterV3(document);

  document.addEventListener('shopify:section:load', function(event) {
    initFooterV3(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    var tab = event.target.closest('.flavor-menu__tab');
    if (!tab) return;

    var menu = tab.closest('.flavor-menu');
    if (!menu) return;

    var target = tab.dataset.tab;
    if (!target) return;

    menu.querySelectorAll('.flavor-menu__tab').forEach(function(button) {
      var isActive = button === tab;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    menu.querySelectorAll('[data-tab-panel]').forEach(function(panel) {
      var isActive = panel.dataset.tabPanel === target;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  });

  (function() {
    var videoObserver = null;

    function getVideo(media) {
      return media.querySelector('video');
    }

    function getToggle(media) {
      return media.querySelector('[data-accordion-video-toggle]');
    }

    function getSoundToggle(media) {
      return media.querySelector('[data-accordion-video-sound]');
    }

    function setSoundState(media, isMuted) {
      var sound = getSoundToggle(media);
      if (!sound) return;

      sound.setAttribute('aria-label', isMuted ? 'Activer le son' : 'Couper le son');
      sound.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
      media.classList.toggle('is-unmuted', !isMuted);
    }

    function isOpen(media) {
      var details = media.closest('details');
      return !details || details.open;
    }

    function setToggleState(media, isPlaying) {
      var toggle = getToggle(media);
      if (!toggle) return;

      toggle.setAttribute('aria-label', isPlaying ? 'Mettre en pause' : 'Lire la vidéo');
      toggle.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    }

    function warmVideo(video) {
      if (video.dataset.accordionVideoWarmed === 'true') return;
      video.dataset.accordionVideoWarmed = 'true';
      video.preload = 'auto';
      video.load();
    }

    function pauseVideo(media) {
      var video = getVideo(media);
      if (!video) return;

      video.pause();
      media.classList.remove('is-playing');
      media.classList.remove('is-awaiting-frame');
      setToggleState(media, false);
    }

    function playVideo(media) {
      var video = getVideo(media);
      if (!video || !isOpen(media)) return;

      warmVideo(video);
      media.classList.add('is-awaiting-frame');

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {
          media.classList.remove('is-awaiting-frame');
          setToggleState(media, false);
        });
      }
    }

    function initAccordionVideos(root) {
      var medias = (root || document).querySelectorAll('[data-accordion-video-media]');
      if (!medias.length) return;

      medias.forEach(function(media) {
        if (media.dataset.accordionVideoInit === 'true') return;

        var video = getVideo(media);
        if (!video) return;

        media.dataset.accordionVideoInit = 'true';

        video.addEventListener('playing', function() {
          media.classList.add('is-playing');
          media.classList.remove('is-awaiting-frame');
          setToggleState(media, true);
        });

        video.addEventListener('pause', function() {
          media.classList.remove('is-playing');
          media.classList.remove('is-awaiting-frame');
          setToggleState(media, false);
        });

        video.addEventListener('ended', function() {
          media.classList.remove('is-playing');
          media.classList.remove('is-awaiting-frame');
          setToggleState(media, false);
        });

        var toggle = getToggle(media);
        if (toggle) {
          toggle.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();

            if (media.classList.contains('is-playing') || !video.paused) {
              pauseVideo(media);
            } else {
              playVideo(media);
            }
          });
        }

        var sound = getSoundToggle(media);
        if (sound) {
          setSoundState(media, video.muted);
          sound.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            video.muted = !video.muted;
            if (!video.muted) {
              video.volume = 1;
            }
            setSoundState(media, video.muted);
          });
          video.addEventListener('volumechange', function() {
            setSoundState(media, video.muted);
          });

          var tryUnmute = function() {
            if (!video.muted) return;
            video.muted = false;
            video.volume = 1;
            setSoundState(media, false);
          };
          ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach(function(evt) {
            window.addEventListener(evt, tryUnmute, { once: true, passive: true, capture: true });
          });
        }

        var details = media.closest('details');
        if (details) {
          details.addEventListener('toggle', function() {
            if (details.open) {
              playVideo(media);
            } else {
              pauseVideo(media);
            }
          });
        }

        if (videoObserver) {
          videoObserver.observe(media);
        } else if (isOpen(media)) {
          playVideo(media);
        }
      });
    }

    if ('IntersectionObserver' in window) {
      videoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            playVideo(entry.target);
          } else {
            pauseVideo(entry.target);
          }
        });
      }, { rootMargin: '240px 0px', threshold: 0.01 });
    }

    initAccordionVideos(document);

    document.addEventListener('shopify:section:load', function(event) {
      initAccordionVideos(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
